// extracted by mini-css-extract-plugin
export default {"card":"styles_card__1P9qx","space":"styles_space__sp4eW","logo":"styles_logo__Dq3Sx","content":"styles_content__Hzj-t"};